import $ from 'jquery';

function checkVal() {
	var $el = $(this);
	var showClass = 'has-value';
	var label = $el.prev('label');

	if($el.val() !== '') {
		label.addClass(showClass);
	} else{
		label.removeClass(showClass);
	}
}

function floatLabel() {
	var onClass = 'has-focus';
	var selector = 'input, textarea, select';

	$(document)
		.on('checkval', selector, checkVal)
		.on('change click keyup input paste', selector, function() {
			checkVal.call(this);
		}).on('focus', selector, function() {
			checkVal.call(this);
			$(this).prev('label').addClass(onClass);
		}).on('blur', selector, function() {
			checkVal.call(this);
			$(this).prev('label').removeClass(onClass);
		}).on('load', selector, function() {
			$(this).trigger('checkval');
		});
}

$(floatLabel);
